import React, { useEffect, useState } from 'react';
import contrato from "../../image/contratoIcon3.png";
import pdfContrato from "../../image/pdfContratoIcon.png";
import { AiOutlineClose } from 'react-icons/ai';
import { IconContext } from "react-icons";
import Card from 'react-bootstrap/Card';
import icon from '../../image/contratoIconGreen.svg'

import './styles.css'
import { useTheme } from '@mui/material';
import HeaderBody from '../../components/HeaderBody';

function Contrato({setShowContrato, data}) {
    const theme = useTheme();
    const user = data;
    const openPdf = (url) => {
        window.open(url, '_blank', 'noreferrer');
    }
    const [height, setWidth] = useState(0);
    useEffect(() => {
        const element = document.getElementById('home');
        if (element) {
          setWidth(element.getBoundingClientRect().height - 260); // or height
        }
    }, []);
    return (
        <Card style={{margin: 20}} className={theme.palette.mode === "dark" ? "bg-dark text-white" : null}>
            <Card.Header>
                <HeaderBody title={"Contrato"} icon={icon} setShow={setShowContrato} />
            </Card.Header>
            <Card.Body className='row' style={{paddingTop: 0, paddingBottom: 0}}>
                <div style={{overflow: "auto", height: height, marginLeft: 20, marginTop: 20}}>
                    <div style={{fontSize: 30, fontWeight: 400, color: "var(--main-secondy)"}}>
                        Status:  
                        <span style={{ color: "var(--main-bg-color)", marginLeft: 5 }}>
                            {user.status}
                        </span>
                    </div>
                    <div style={{fontSize: 25, fontWeight: 700}}>
                        Nome: {user.name}
                    </div>
                    <div style={{fontSize: 20, color: "var(--main-secondy)", fontWeight: 300, marginBottom: 30}}>
                        {user.residuo}
                    </div>
                    <div style={{backgroundColor: "#DDD7D7", height: 2, width: "100%"}}></div>
                    <div style={{marginTop: 30}}>
                        <img src={contrato} height="35" width="35" alt="icon contrato" />
                    </div>
                    <div style={{marginTop: 30, fontSize: 22, fontWeight: 700, color: "var(--main-secondy)"}}>
                        {user.tipo}
                    </div>
                    <div style={{marginTop: 20, fontSize: 25, fontWeight: 700, color: "var(--main-font)"}}>
                        {user.cnpj}
                    </div>
                    <div style={{marginTop: 0, fontSize: 20, fontWeight: 300, color: "var(--main-secondy)"}}>
                        {user.endereco} 
                    </div>
                    <div className="cards row" style={{marginTop: 50, marginBottom: 50}}>
                        <div className="col-sm-10 col-xs-10 col-10 col-md-6 col-lg-6 col-xl-4">
                            <div style={{marginTop: 30, backgroundColor: "#EEE7E7",  padding: 20,
                                borderRadius: 14,
                                cursor: "pointer",
                                margin: 0,}}
                                onClick={() => openPdf("https://greenium.com.br/cliente/painel2.php?execute=suporte/contrato/imprimir-atualizacao-contrato&contratoId=" + user.idContrato)}
                                >
                                <img src={pdfContrato} height="35" alt="icon contrato"  style={{ marginRight: 15, marginLeft: 10 }} />
                            </div>
                        </div>
                    </div>
                </div>
                
            </Card.Body>
        </Card>
    );
}

export default Contrato;